import React, { useState, useEffect } from "react";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import { getListNguonVon } from "../../actions/NguonVon";
import { formatNumber } from "utils/currencyFormat";
import { BtnThemMoiGopVon } from "./ThemMoi/BtnThemMoiGopVon";
import PhanTrang from "components/CommonComponent/PhanTrang";

export const TableDanhSach = ({
  themmoinguonvon,
  quyenGopVon,
  quyenRutVon,
  quyenSuaNguonVon,
}) => {
  const dispatch = useDispatch();
  const listNguonVonFull = useSelector((state) => state.listNguonVonFull);
  const dataSearch = useSelector((state) => state.dataSearchNguonVon);
  // API trả toàn bộ danh sách (không phân trang) nên phân trang phía client
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  useEffect(() => {
    dispatch(getListNguonVon(dataSearch));
  }, []);
  useEffect(() => {
    setPageIndex(1);
  }, [listNguonVonFull.List]);

  const handlePageChange = (pageNumber) => {
    setPageIndex(pageNumber);
    loadNguonVon();
  };
  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPageIndex(1);
  };
  const loadNguonVon = () => {
    getListNguonVon(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang
  const list = listNguonVonFull.List || [];
  const startIndex = (pageIndex - 1) * pageSize;
  const pageList = list.slice(startIndex, startIndex + pageSize);
  return (
    <>
      <div
        className="card border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          {themmoinguonvon && (
            <div className="iconbutton-new ">
              <div className="row">
                <div className="col-sm-12 col-md-9">
                  <BtnThemMoiGopVon />
                </div>
                <div className="col-sm-12 col-md-3 d-flex just-end"></div>
              </div>
            </div>
          )}
          <br />
          <div className="Left808x200 Table-main-new">
            <div className="loading-page1">
              <div
                className={
                  "loader loader-default " +
                  (listNguonVonFull.getListNguonVonLoading ? "is-active" : "")
                }
              ></div>
            </div>
            <div className="table-mobile sticky-table-bh2 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {listNguonVonFull.TongBanGhi} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-26 flex-basis-23-6-sm">
                    <p className="text-center">Mã Cổ đông</p>
                  </div>

                  <div className="custom-table-header flex-basis-17 flex-basis-19-sm">
                    <p className="text-left">Cổ đông</p>
                  </div>

                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="tab-header  text-center">Ngày</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-12-8-sm">
                    <p className="tab-header  text-right">
                      Số tiền
                      <br />
                      <span className="color-xanh-bold">
                        {formatNumber(listNguonVonFull.TongTien)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header text-center">Tỷ lệ vốn</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-8-6-sm action-cell">
                    <p className="tab-header">Chức năng</p>
                  </div>
                </div>
                <div className="custom-table-body">
                  <ContentTable
                    listNguonVonFull={pageList}
                    quyenGopVon={quyenGopVon}
                    quyenRutVon={quyenRutVon}
                    quyenSuaNguonVon={quyenSuaNguonVon}
                    startIndex={startIndex}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card mb-3 border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <PhanTrang
            pageIndex={pageIndex}
            pageSize={pageSize}
            totalCount={list.length}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
    </>
  );
};
